module.exports = __webpack_public_path__ + "static/img/list-bj.101cd099.png";